import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/section.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

function LLMs() {
    return (
        <div className="section-container">
            <Header />
            <main className="section-content">
                <p className="section-intro-paragraph">Learn about ChatGPT</p>
                <div className="subsection-links">
                    <Link to="/llms/basics">Basics</Link>
                    <Link to="/llms/training">Training</Link>
                    <Link to="/llms/distillation">Distillation</Link>
                    <Link to="/llms/applications">Applications</Link>
                    <Link to="/llms/ethics">Ethics</Link>
                </div>
            </main>
            <Footer />
        </div>
    );
}

export default LLMs;